__turbopack_context__.v({
  "alignmentLeft": "XQMJ0a_alignmentLeft",
  "alignmentRight": "XQMJ0a_alignmentRight",
  "alignmentTop": "XQMJ0a_alignmentTop",
  "controlWrapper": "XQMJ0a_controlWrapper" + " " + "controlWrapper",
  "feedbackText": "XQMJ0a_feedbackText" + " " + "feedbackText",
  "fieldMain": "XQMJ0a_fieldMain" + " " + "fieldMain",
  "formFieldDisabled": "XQMJ0a_formFieldDisabled",
  "formFieldWrapper": "XQMJ0a_formFieldWrapper",
  "header": "XQMJ0a_header" + " " + "header",
  "helpText": "XQMJ0a_helpText" + " " + "helpText",
  "label": "XQMJ0a_label" + " " + "label",
  "labelWrapper": "XQMJ0a_labelWrapper" + " " + "labelWrapper",
  "optionalLabel": "XQMJ0a_optionalLabel" + " " + "optionalLabel",
  "sizeFull": "XQMJ0a_sizeFull",
  "sizeL": "XQMJ0a_sizeL",
  "sizeM": "XQMJ0a_sizeM",
  "sizeS": "XQMJ0a_sizeS",
  "sizeXS": "XQMJ0a_sizeXS",
  "sizeXXS": "XQMJ0a_sizeXXS",
});
